import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

// Get user session value from sessionStorage
const userData = JSON.parse(sessionStorage.getItem('user'))
const loggedIn = !!userData
let isUserAdmin = false;

// console.log(`[router] userData: `, userData);
// console.log(`[router] loggedIn: `, loggedIn);

if (loggedIn) {
  const role = userData.role;
  isUserAdmin = (role && role === 'admin') ? true : false;
}

// console.log(`[router] isUserAdmin: `, isUserAdmin);

const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/health',
    name: 'health',
    component: () => import(/* webpackChunkName: "login" */ '../views/Health.vue'),
  },
  // {
  //   path: '/about',
  //   name: 'about',
  //   component: () => import(/* webpackChunkName: "login" */ '../views/About.vue'),
  // },
  {
    path: '/docs',
    name: 'docs',
    props: true,
    component: () => import(/* webpackChunkName: "login" */ '../views/Documentation.vue'),
    children: [
      {
        path: ':entryId',
        name: "docPage",
        props: true,
        component: () =>
          import(/*webpackChunkName: "ExperienceDetails"*/ "../components/DocsPageFull")
      },
      {
        path: '',
        name: "docPage.default",
        component: () => import(/*webpackChunkName: "ExperienceDetails"*/ "../components/DocsPageDefault")
      }
    ]
  },
  {
    path: '/integration-features',
    name: 'features',
    component: () => import(/* webpackChunkName: "login" */ '../views/Features.vue'),
  },
  {
    path: '/forgetPassword',
    name: 'forgetPassword',
    component: () => import(/* webpackChunkName: "login" */ '../views/ForgetPassword.vue'),
  },
  {
    path: '/resetPassword',
    name: 'resetPassword',
    component: () => import(/* webpackChunkName: "login" */ '../views/ResetPassword.vue'),
  },
  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "login" */ '../views/Login.vue'),
    beforeEnter(to, from, next) {
      if (loggedIn) {
        if (isUserAdmin){
          next('accounts')
        } else {
          next('customerAccount')
        }
      }
      next();
    }
  },
  {
    path: '/registration',
    name: 'registration',
    component: () => import(/* webpackChunkName: "signup" */ '../views/Signup.vue'),
    beforeEnter(to, from, next) {
      if (loggedIn) {
        if (isUserAdmin) {
          next('accounts')
        } else {
          next('customerAccount')
        }
      }
      next();
    }
  },
  {
    path: '/requests',
    name: 'requests',
    // route level code-splitting
    // this generates a separate chunk (requests.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "requests" */ '../views/AdminRequestsDashboard.vue'),
    meta: { 
      requiresAuth: true,
      userIsAdmin: true
    }
  },
  {
    path: '/accounts',
    name: 'accounts',
    // route level code-splitting
    // this generates a separate chunk (accounts.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "accounts" */ '../views/AdminAccountsDashboard.vue'),
    meta: { 
      requiresAuth: true,
      userIsAdmin: true
    }
  },
  {
    path: '/adminUsers',
    name: 'AdminUsers',
    component: () => import(/* webpackChunkName: "accounts" */ '../views/SuperAdminsDashboard.vue'),
    meta: { 
      requiresAuth: true,
      userIsAdmin: true
    }
  },
  // {
  //   path: '/adminAccountUsage',
  //   name: 'adminAccountUsage',
  //   // route level code-splitting
  //   // this generates a separate chunk (adminAccountUsage.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "adminAccountUsage" */ '../views/AdminAccountUsage.vue'),
  //   meta: { 
  //     requiresAuth: true,
  //     userIsAdmin: true
  //   }
  // },
  {
    path: '/adminSettings',
    name: 'adminSettings',
    // route level code-splitting
    // this generates a separate chunk (adminSettings.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "adminSettings" */ '../views/AdminSettings.vue'),
    meta: { 
      requiresAuth: true,
      userIsAdmin: true
    }
  },  
  {
    path: '/adminReports',
    name: 'adminReports',
    // route level code-splitting
    // this generates a separate chunk (adminSettings.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "adminReports" */ '../views/AdminReports.vue'),
    meta: {
      requiresAuth: true,
      userIsAdmin: true
    }
  },
  {
    path: '/customerAccount',
    name: 'customerAccount',
    // route level code-splitting
    // this generates a separate chunk (adminSettings.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "customerAccount" */ '../views/CustomerAccount.vue'),
    meta: {
      requiresAuth: true,
      userIsCustomer: true
    }
  },
  {
    path: '/customerReports',
    name: 'customerReports',
    // route level code-splitting
    // this generates a separate chunk (adminSettings.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "customerReports" */ '../views/CustomerReports.vue'),
    meta: {
      requiresAuth: true,
      userIsCustomer: true
    }
  },
  {
    path: '/customerSettings',
    name: 'customerSettings',
    // route level code-splitting
    // this generates a separate chunk (customerSettings.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "customerSettings" */ '../views/CustomerSettings.vue'),
    meta: {
      requiresAuth: true,
      userIsCustomer: true
    }
  },
  {
    path: '/customerWidgetConfig',
    name: 'customerWidgetConfig',
    // route level code-splitting
    // this generates a separate chunk (customerWidgetConfig.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "customerWidgetConfig" */ '../views/CustomerWidgetConfig.vue'),
    meta: {
      requiresAuth: true,
      userIsCustomer: true
    }
  },
  {
    path: '/customerLinkTranscripts',
    name: 'customerLinkTranscripts',
    // route level code-splitting
    // this generates a separate chunk (customerLinkTranscripts.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "customerLinkTranscripts" */ '../views/CustomerLinkTranscripts.vue'),
    meta: {
      requiresAuth: true,
      userIsCustomer: true
    }
  },
  {
    path: '*',
    // redirect: '/',
    beforeEnter(to, from, next) {
      if (loggedIn) {
        if (isUserAdmin) {
          next('accounts')
        } else {
          next('customerAccount')
        }
      } else {
        next('/login')
      }
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// before redirect to selected route
router.beforeEach((to, from, next) => {
  const userData = JSON.parse(sessionStorage.getItem('user'))
  const loggedIn = !!userData
  let isUserAdmin = false;

  // console.log(`[router.beforeEach] userData: `, userData);
  // console.log(`[router.beforeEach] loggedIn: `, loggedIn);

  if (loggedIn) {
    const role = userData.role;
    isUserAdmin = (role && role === 'admin') ? true : false;

    // console.log(`[router.beforeEach] role: `, role);
    // console.log(`[router.beforeEach] isUserAdmin: `, isUserAdmin);
  }

  if (loggedIn && !isUserAdmin) {
    // console.log(`[router.beforeEach] - loggedIn && !isUserAdmin: `, isUserAdmin);

    // cannot access the route 'customerWidgetConfig' directly
    // if (to.path === '/customerWidgetConfig' && from.path !== '/customerAccount') {
    if (to.path === '/customerWidgetConfig' && !to.params.hasOwnProperty('itemConfig')) {
      next('/customerAccount')
    }
  }
  
  if (!loggedIn) {
    // console.log(`[router.beforeEach] IF loggedIn: `, loggedIn);
    // check for routes with metadata information: requiresAuth
    if (to.matched.some(record => record.meta.requiresAuth)){
      next('/login')
    }
  } else {
    // console.log(`[router.beforeEach] ELSE loggedIn: `, loggedIn);
    
    // if an Customer try access an Admin route
    if (to.matched.some(record => record.meta.userIsAdmin)) {
      if (!isUserAdmin) {
        next('/customerAccount')
      }
    } 

    // if an Admin try access a Customer route
    if (to.matched.some(record => record.meta.userIsCustomer)) {
      if (isUserAdmin) {
        next('/accounts')
      }
    } 
  }
  next();
})

export default router
